module.exports = __webpack_public_path__ + "image/logo.1782790484418.png";